import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[mrsoftappsReferenceFormView]'
})
export class ReferenceFormDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
